import { ExternalLink, Info } from "lucide-react";
import { RecordSteps } from "./RecordSteps";

export function GuidePanel({ d }) {
  const g = d.guide;
  return (
    <div className="space-y-4" data-testid="domain-guide">
      <div className="rounded-xl border p-4 space-y-2">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <p className="font-semibold text-[#062a20]">Step 1: Open your DNS settings at {g.name}</p>
          {g.dns_url && <a href={g.dns_url} target="_blank" rel="noreferrer" className="btn-emerald !py-2 !text-xs" data-testid="domain-provider-link"><ExternalLink className="w-3.5 h-3.5" />Open {g.name} in a new tab</a>}
        </div>
        <ol className="list-decimal pl-5 space-y-1.5 text-sm text-slate-700" data-testid="domain-guide-steps">{g.steps.slice(0, -2).map((s) => <li key={s}>{s}</li>)}</ol>
        <p className="text-xs text-slate-500">Menu names change from time to time. If something looks different, search {g.name}'s help pages for "add CNAME record".</p>
      </div>
      <div className="rounded-xl border p-4 space-y-2">
        <p className="font-semibold text-[#062a20]">Step 2: Add the records, copying and pasting each value</p>
        <RecordSteps records={d.records} provider={g.name} />
      </div>
      {d.records.some((r) => r.type === "A") && <p className="text-xs text-slate-600 bg-[#f4efe2] rounded-lg p-2" data-testid="domain-apex-note">The A record with Name "@" connects your main domain <b>{d.root}</b>, and the CNAME connects <b>{d.hostname}</b>. Both open your website.</p>}
      <div className="rounded-xl border p-4 space-y-1">
        <p className="font-semibold text-[#062a20]">Step 3: Come back here and click Verify DNS</p>
        <p className="text-xs text-slate-600 flex gap-1.5"><Info className="w-4 h-4 shrink-0 text-[#c9a13b]" />DNS changes usually show up within 30 minutes, but can take up to 48 hours to reach everyone. We also keep checking in the background and let you know.</p>
      </div>
    </div>);
}

const TIPS = [
  ["It still says \"Not found\"", "Wait 15–30 minutes and click Check Again. Make sure you saved the change, and that you edited the domain you entered here."],
  ["It says the record points somewhere else", "There's an old record with the same name. Edit it to the new value, or delete it and add the new one."],
  ["There's already an A record for @", "Edit it so it points to the value shown above, or delete it and add the new one. Keep only the A records listed here for @."],
  ["My provider added my domain name to the end", "Some providers add your domain automatically. Enter only the part shown in Host / Name (for example www), not the full address."],
  ["I use Cloudflare and it isn't verifying", "Set the record's Proxy status to DNS only (grey cloud), then check again."],
  ["SSL failed", "Make sure DNS is verified, remove any old AAAA records, then click Retry SSL."],
];

export function Troubleshooting() {
  return (
    <details className="rounded-xl border border-slate-200 p-3 group" data-testid="domain-troubleshooting">
      <summary className="cursor-pointer font-semibold text-[#062a20] text-sm">Troubleshooting common problems</summary>
      <dl className="mt-2 space-y-2 text-sm">{TIPS.map(([q, a]) => <div key={q}><dt className="font-medium">{q}</dt><dd className="text-slate-600">{a}</dd></div>)}</dl>
    </details>);
}
